var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}},_vm.$listeners),[_c('path',{attrs:{"d":"M10.46 19.82v26.36h43.08V19.82L33 36.37a1.57 1.57 0 01-2 0zm2.52-2L32 33.13l19-15.31z","fill":"#fff"}})])}
var staticRenderFns = []

export { render, staticRenderFns }